import { render, staticRenderFns } from "./WalbingReferrer.vue?vue&type=template&id=20a22130&"
import script from "./WalbingReferrer.vue?vue&type=script&lang=js&"
export * from "./WalbingReferrer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports